import React, { useCallback, useEffect } from 'react';
import useResourcesStore from '@monorepo/shared/src/graph/state/query-hooks/use-resources';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';

type Props = {
  selectedLetter: string | undefined;
};

const LetterResources: React.FC<Props> = ({ selectedLetter }) => {
  const [resourceStore] = useResourcesStore(selectedLetter ?? undefined);
  const [{ resources }, { setResources }] = useResources();

  const handleOnPinClick = useCallback(() => null, []);

  useEffect(() => {
    setResources(resourceStore.resources);
  }, [resourceStore.isLoading, selectedLetter]);

  const data = selectedLetter && !resourceStore.isLoading ? resources : [];

  return (
    <ResourcesList
      resources={data}
      onPinClick={handleOnPinClick}
      areDisplayingCardHeaders={false}
    />
  );
};

export default LetterResources;
